var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSignupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.68 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f2f32;filter:url(#Shadow_3);}"), /*#__PURE__*/React.createElement("filter", {
    id: "Shadow_3",
    x: "-15%",
    y: "-15%",
    width: "140%",
    height: "130%",
    name: "Shadow_3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    result: "offsetBlurredAlpha",
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offsetBlurredAlpha"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.59,3.3H7.2A2.15,2.15,0,0,0,5.05,5.45v17.7A2.15,2.15,0,0,0,7.2,25.3H36.59a2.15,2.15,0,0,0,2.15-2.15V5.45A2.15,2.15,0,0,0,36.59,3.3Zm-13.69,11a1.67,1.67,0,0,1-2,0L9,5.3H34.77Zm-5.36,0-10.49,8v-16Zm1.65,1.26.49.37a3.69,3.69,0,0,0,4.43,0l.49-.37L34.77,23.3H9Zm7.06-1.26,10.49-8v16Z",
    transform: "translate(-5.05 -3.3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSignupIcon);
export default __webpack_public_path__ + "static/media/emailSignupIcon.fa0f1720d6a89c0f7371bdaacb75b53f.svg";
export { ForwardRef as ReactComponent };